import React, { useState } from 'react';
import Modal from 'app/src/elements/Modal';
import AnnouncementInput from '../../Sales/Announcements/AnnouncementInput';
import AnnouncementIcon from '../../Sales/Announcements/AnnouncementIcon';
import { dollars, numberWithDelimiter } from 'app/src/utils/stringHelpers';

import {
  Title,
  Button,
  GOING_BUTTONS,
  SuggestionsContainer
} from '../elements';

const COLORS = {
  bid: 'lawngreen',
  sold: 'darkgreen',
  pass: colors.elRed,
};

import colors from 'app/src/styles/colors';

const AssetButtons = ({ saleAsset, updateBiddingStatus, bidLength,
  reservePrice, confirmSold, bids, sale, setIsIf, biddingPass,
  disableSoldButtons, setDisableSoldButtons
}) => {

  const [showBlastModal, setShowBlastModal] = useState(false);
  const [saleAssetAnnouncements, setSaleAssetAnnouncements] = useState(false);
  const [announcementAssetDetails, setAnnouncementAssetDetails] = useState(false);

  return (
    <>
      {/* <SuggestionsContainer>
        {GOING_BUTTONS.map(({ status, color }) => (
          <React.Fragment key={status}>
            {status === saleAsset.biddingStatus ? (
              <Button
                title={`Clear - ${status}`}
                color="gray"
                onPress={() => updateBiddingStatus('Pending')}
              />
            ) : (
              <Button
                disabled={0 === bidLength}
                title={status}
                color={color}
                onPress={() => updateBiddingStatus(status)}
              />
            )}
          </React.Fragment>
        ))}
      </SuggestionsContainer> */}
      <SuggestionsContainer>
        <Button
          title="Blast"
          color="violet"
          onPress={() => {
            setAnnouncementAssetDetails(
              `${saleAsset.lotNumber} | ${saleAsset.asset.name}`
            );
            setShowBlastModal(saleAsset)
          }}
        />
        <Button
          title="Pass"
          color={COLORS.pass}
          onPress={
            () => biddingPass({ variables: { saleAssetId: saleAsset.id }})
          }
        />
      </SuggestionsContainer>
      <SuggestionsContainer style={{alignItems: 'center'}}>
        {reservePrice > 0 ? (
          <Title style={{width: '50%', maxWidth: '50%', textAlign: 'center'}}>
            Reserve: {dollars(reservePrice)}
          </Title>
        ) : (
          <Title style={{width: '50%', maxWidth: '50%', textAlign: 'center'}}>
            No Reserve
          </Title>
        )}
        <Button
          disabled={0 === bids.length || disableSoldButtons}
          title="Sold!"
          color={COLORS.sold}
          onPress={() => {
            setIsIf(false);
            confirmSold(false);
          }}
          style={{maxWidth: '50%'}}
        />
      </SuggestionsContainer>
      <SuggestionsContainer>
        <Button
            disabled={0 === bids.length || disableSoldButtons}
            title="Pending Seller Confirmation"
            color="yellow"
            labelStyle={{ color: 0 === bids.length ? 'white' : 'black' }}
            // labelStyle={{ color: 'black' }}
            onPress={() => {
              setIsIf(true);
              confirmSold();
            }}
          />
      </SuggestionsContainer>
      {showBlastModal && (
        <Modal
          showModal={showBlastModal}
          setShowModal={setShowBlastModal}
          modalType={`${announcementAssetDetails || ''} Announcement`}
        >
          <AnnouncementInput
            saleAsset={saleAsset}
            sale={sale}
            setShowModal={setShowBlastModal}
            setDisableSoldButtons={setDisableSoldButtons}
          />
        </Modal>
      )}
      {saleAssetAnnouncements &&
        <Modal
          showModal={saleAssetAnnouncements}
          setShowModal={setSaleAssetAnnouncements}
          modalType={`${announcementAssetDetails || ''} Announcements`}
        >
          <View>
            {
              saleAssetAnnouncements.map(announcement => {
                return <View style={{margin: '10px'}}>
                  {announcement.body}
                </View>
              })
            }
          </View>
        </Modal>
      }
    </>
  )
}

export default AssetButtons;